import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DestroyService } from '../../services/destroy/destroy.service';
import { CustomerNote, CustomerNoteModel, CustomerNoteServiceProxy, CustomerServiceProxy, FilterModel, SortOrder } from '../../../shared/service-proxies/event-service-proxy';
import { takeUntil } from 'rxjs';
import { DateFormatterPipe } from '../../pipes/date/date-formatter.pipe';
import { ErrorService } from '../../services/error/error.service';
import { ModalService } from '../../services/modal/modal.service';

@Component({
    selector: 'app-comment',
    templateUrl: './comment.component.html',
    styleUrl: './comment.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class CommentComponent implements OnInit {
  @Input() customerId: string = '';
  @Input() refreshTrigger: boolean = false;
  @Input() deletedComment: boolean = false;
  @Output() changeNotes = new EventEmitter<boolean>();
  @Output() editClick = new EventEmitter<CustomerNoteModel | null>();
  @Output() deleteClick = new EventEmitter<CustomerNoteModel|null>();

  page: number = 0;
  perPage: number = 0;
  sortOrder: SortOrder = SortOrder.Asc;
  sortBy: string = 'createdAt'
  isLoading: boolean = true;

  customerNotes: CustomerNoteModel[] = [];
  customerNote: CustomerNote = new CustomerNote();
  dataMissing: boolean|string = false;


  activeNoteId: string | null = null;
  menuPosition = { x: 0, y: 0 };

  lastEditedNoteId: string | null = null; 

  constructor(private modalService: ModalService, private errorService: ErrorService, private _customerService: CustomerServiceProxy, private destroyService: DestroyService, private dateFormatterPipe: DateFormatterPipe, private _customerNoteService: CustomerNoteServiceProxy) { }
  
  ngOnInit(): void {
    document.addEventListener('click', this.hideContextMenu.bind(this));
  }

  ngOnChanges(): void {
    this.getNotes();
  }

  getNotes() {
    this._customerService.getNotes(this.customerId, new FilterModel({page:this.page, perPage:this.perPage, sortOrder:this.sortOrder, sortBy: this.sortBy}))
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(customerNote => {
        this.customerNotes = customerNote.items;
        this.changeNotes.emit(true);
        this.isLoading = false;
        this.dataMissing = this.customerNotes.length == 0;
      }, error => {
        console.log(error);
        this.isLoading = false;
        this.dataMissing = 'Не удалось получить комментарии. Попробуйте позже.';
        this.errorService.handleError(error, 'Не удалось получить комментарии. Попробуйте позже.');
      })
  }

  showMessageActionMenu(event: MouseEvent, noteId: string) {
    event.preventDefault(); 

    this.activeNoteId = noteId;
    this.menuPosition = { x: event.clientX, y: event.clientY };
    console.log(this.menuPosition);
    
  }

  hideContextMenu() {
    this.activeNoteId = null; 
  }

  editMessage(note: CustomerNoteModel) {
    this.editClick.emit(note);
    this.hideContextMenu();
  }

  deleteMessage(note: CustomerNoteModel) {
    this.deleteClick.emit(note);
    this.openModal('deleteNote')
  }

  openModal(popup: string) {
    this.modalService.openModal(popup);
  }

}
